import { ObjectHelpers } from "../../helpers/object-helpers";

export class TemporaryStopLossModel {
    public accountName = '';
    public symbol = '';
    public price = 0;
    public stopType: TemporaryStopLossType | null = null;
    public minMaxStopPrice: number | null = null;
    public entryTime: Date | null = null;
    public zIndex = 1;

    constructor(data: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}

export const enum TemporaryStopLossType {
    TradeWave,
    Trailing,
    Forced
}